import { useRouter } from 'vue-router';

import type { ISiteTemplate } from './types';

import { useSiteTemplateApi } from '../api';

export const useSiteTemplates = defineStore('site-template', () => {
  const { fetchAll, select } = useSiteTemplateApi();

  const { $toast } = useNuxtApp();

  const templates = ref<Array<ISiteTemplate>>([]);

  const router = useRouter();

  const fetchTemplates = async () => {
    try {
      templates.value = await fetchAll();
    } catch (err: any) {
      if (err.status === 403) {
        router.push('forbidden');
      }

      if (err.status === 401) {
        router.push('unauthorized');
      }
      if (import.meta.client) {
        $toast.error('Произошла ошибка. Не удалось загрузить список шаблонов сайтов.');
      }
    }
  };

  const selectTemplate = async (templateId: string) => {
    try {
      await select(templateId);
    } catch {
      if (import.meta.client) {
        $toast.error('Произошла ошибка. Не удалось применить выбранный шаблон для сайта.');
        return;
      }
    }

    await router.push('/');
    router.go(0);
  };

  return { templates, fetchTemplates, selectTemplate };
});
